/**
 * CrawlWaitingOverlay -- Dialog wrapper around the shared CrawlWaitingContent.
 *
 * Used by the admin setup wizard (PracticeIdentityStep) to show a fun
 * "while you wait" experience during website crawling.
 *
 * The inner content is shared with the provider onboarding ParsingStep
 * via CrawlWaitingContent.
 */
import React from 'react';
import { Dialog, DialogContent } from '@mui/material';
import CrawlWaitingContent from '../../../../components/shared/CrawlWaitingContent';

interface CrawlWaitingOverlayProps {
  open: boolean;
  /** Optional callback when user clicks the safety close button (after timeout). */
  onClose?: () => void;
}

export default function CrawlWaitingOverlay({ open, onClose }: CrawlWaitingOverlayProps) {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      slotProps={{
        backdrop: { sx: { backdropFilter: 'blur(4px)' } },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <CrawlWaitingContent
          active={open}
          onSafetyClose={onClose}
        />
      </DialogContent>
    </Dialog>
  );
}
